import React, { Component } from 'react'
import { inject, observer } from 'mobx-react'
import PropTypes from 'prop-types'

import { projectApi } from '@atheneum/api'

import { StatusLabel } from '@components/StatusLabel'
import Star from '@components/Icon/Star'
import { formatDate } from '@atheneum/api/dist/lib'

class ProjectsTable extends Component {
  static propTypes = {
    projects: PropTypes.object,
    sidebarStore: PropTypes.object,
    modalStore: PropTypes.object
  }

  showClientFeedback = async project => {
    const feedbacks = await projectApi.getClientFeedbacks(project.id)
    if (!feedbacks.length) return

    return this.props.modalStore.show({
      type: 'CLIENT_FEEDBACK',
      props: {
        feedbacks,
        project
      }
    })
  }

  render () {
    const { projects } = this.props
    return (
      <table className='table-wrapper invoice-table projects'>
        <thead>
          <tr>
            <th>Project Name</th>
            <th>Client office</th>
            <th>Client contact</th>
            <th>Start date</th>
            <th>End date</th>
            <th>Status</th>
            <th>Exp requested</th>
            <th>Exp interviewed</th>
            <th>Client Feedback</th>
          </tr>
        </thead>
        {projects.map(project => {
          return (
            <tbody key={project.id}>
              <tr>
                <td>
                  <span
                    className='row--link'
                    onClick={() =>
                      this.props.sidebarStore.openSidebar({
                        template: 'project',
                        id: project.id
                      })
                    }
                  >
                    {project.name}
                  </span>
                </td>
                <td>
                  <span
                    className='row--link'
                    onClick={() =>
                      this.props.sidebarStore.openSidebar({
                        template: 'client-office',
                        id: project.officeId
                      })
                    }
                  >
                    {project.office}
                  </span>
                </td>
                <td>
                  {project.clientData.map(client => {
                    return (
                      <div
                        key={client.id}
                        onClick={() =>
                          this.props.sidebarStore.openSidebar({
                            template: 'client-contact',
                            id: client.id
                          })
                        }
                        className='row--link'
                      >
                        {client.title} {client.firstName} {client.lastName}
                      </div>
                    )
                  })}
                </td>
                <td>
                  <span className='text-wrapper'>
                    {formatDate(project.startDate)}
                  </span>
                </td>
                <td>
                  <span className='text-wrapper'>
                    {formatDate(project.endDate)}
                  </span>
                </td>
                <td>
                  <StatusLabel
                    statusId={project.statusId}
                    statusesType='projectStatuses'
                  />
                </td>
                <td>
                  <span className='text-wrapper center'>
                    {project.requested}
                  </span>
                </td>
                <td>
                  <span className='text-wrapper center'>
                    {project.interviewed}
                  </span>
                </td>
                <td className='text-wrapper center'>
                  {project.clientFeedback ? (
                    <div className='center-children'>
                      <div
                        className='flex-center clickable'
                        onClick={() => this.showClientFeedback(project)}
                      >
                        <Star />
                        <span>{project.clientFeedback}</span>
                      </div>
                    </div>
                  ) : (
                    '-'
                  )}
                </td>
              </tr>
            </tbody>
          )
        })}
      </table>
    )
  }
}

export default inject('sidebarStore', 'modalStore')(observer(ProjectsTable))
